import { render, staticRenderFns } from "./ReferralLetter.vue?vue&type=template&id=1058915c&scoped=true&"
import script from "./ReferralLetter.vue?vue&type=script&lang=js&"
export * from "./ReferralLetter.vue?vue&type=script&lang=js&"
import style0 from "./ReferralLetter.vue?vue&type=style&index=0&id=1058915c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1058915c",
  null
  
)

export default component.exports